// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__wuUPR","content":"Consent_content__2oozR","footer":"Consent_footer__3OAhj"};